/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import HelpIcon from '@mui/icons-material/Help';
import CategoryIcon from '@mui/icons-material/Category';
import InventoryIcon from '@mui/icons-material/Inventory';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import SearchIcon from '@mui/icons-material/Search';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import NotificationsIcon from '@mui/icons-material/Notifications';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
// import SyncIcon from '@mui/icons-material/Sync';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import SecurityIcon from '@mui/icons-material/Security';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import PersonIcon from '@mui/icons-material/Person';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CampaignIcon from '@mui/icons-material/Campaign';
import { checkPermission } from '../../Utils/permissionHelper';
import './style.css';

const AdminSidebar = () => {
  const [openSidebar, setOpenSidebar] = useState(true);
  const [expandedMenus, setExpandedMenus] = useState({});
  const location = useLocation()

  // Disable hover expand when sidebar is closed
  useEffect(() => {
    const body = document?.body;
    if (!body) return;
    if (!openSidebar) {
      body.classList.add('no-hover-expand');
      const preventExpand = () => {
        if (body.classList.contains('expand-menu')) {
          body.classList.remove('expand-menu');
        }
      };
      document.addEventListener('mouseover', preventExpand, true);
      document.addEventListener('mouseenter', preventExpand, true);
      document.addEventListener('mousemove', preventExpand, true);
      return () => {
        body.classList.remove('no-hover-expand');
        document.removeEventListener('mouseover', preventExpand, true);
        document.removeEventListener('mouseenter', preventExpand, true);
        document.removeEventListener('mousemove', preventExpand, true);
      };
    } else {
      body.classList.remove('no-hover-expand');
    }
    return () => {
      body.classList.remove('no-hover-expand');
    };
  }, [openSidebar]);

  const sideBarData = [
    {
      title: 'Dashboard',
      to: '/admin/dashboard',
      paths: ['/admin/dashboard'],
      icon: DashboardIcon,
      liClassName: 'nav-item',
      permission: null, // Dashboard always visible
    },
    {
      title: 'Admin',
      icon: AdminPanelSettingsIcon,
      hasSubmenu: true,
      submenu: [
        {
          title: 'Users',
          to: '/admin/admin-user-listing',
          paths: ['/admin/admin-user-listing', '/admin/add-admin-user', '/admin/edit-admin-user'],
          icon: PersonIcon,
          permission: 'view-admin-users',
        },
        {
          title: 'Roles',
          to: '/admin/role-listing',
          paths: ['/admin/role-listing', '/admin/add-role', '/admin/edit-role', '/admin/role-detail'],
          icon: SecurityIcon,
          permission: 'view-roles',
        },
      ],
    },
    {
      title: 'Users',
      to: '/admin/client-user-listing',
      paths: ['/admin/client-user-listing', '/admin/client-user-detail'],
      icon: PeopleIcon,
      permission: 'view-users',
    },
    {
      title: 'Guide Product',
      to: '/admin/guide-listing',
      paths: ['/admin/guide-listing', '/admin/add-guide', '/admin/edit-guide', '/admin/guide-detail'],
      icon: HelpIcon,
      permission: 'view-guide-products',
    },
    {
      title: 'Category',
      to: '/admin/category-listing',
      paths: ['/admin/category-listing', '/admin/add-category', '/admin/edit-category'],
      icon: CategoryIcon,
      permission: 'view-categories',
    },
    {
      title: 'Welfare',
      to: '/admin/welfare-listing',
      paths: ['/admin/welfare-listing', '/admin/add-welfare', '/admin/edit-welfare', '/admin/welfare-detail'],
      icon: VolunteerActivismIcon,
      permission: 'view-welfares',
    },
    {
      title: 'Products',
      to: '/admin/product-listing',
      paths: ['/admin/product-listing', '/admin/add-product', '/admin/edit-product', '/admin/product-detail'],
      icon: InventoryIcon,
      permission: 'view-products',
    },
    {
      title: 'Product Variation',
      to: '/admin/product-variations',
      paths: ['/admin/product-variations', '/admin/add-product-variations', '/admin/edit-product-variations'],
      icon: ViewCarouselIcon,
      permission: 'view-product-variations',
    },
    {
      title: 'Discover',
      to: '/admin/discover-listing',
      paths: ['/admin/discover-listing', '/admin/add-discover', '/admin/edit-discover', '/admin/discover-detail'],
      icon: SearchIcon,
      permission: 'view-discovers',
    },
    {
      title: 'Emoji',
      to: '/admin/emoji',
      paths: ['/admin/emoji', '/admin/add-emoji', '/admin/edit-emoji'],
      icon: EmojiEmotionsIcon,
      permission: 'view-emojis',
    },
    {
      title: 'Notification',
      icon: NotificationsIcon,
      hasSubmenu: true,
      submenu: [
        {
          title: 'App Notification',
          to: '/admin/app-notifications',
          paths: ['/admin/app-notifications', '/admin/add-app-notification', '/admin/edit-app-notifications'],
          icon: NotificationsIcon,
          permission: 'view-app-notifications',
        },
        {
          title: 'Push Notification',
          to: '/admin/push-notifications',
          paths: ['/admin/push-notifications', '/admin/add-push-notification', '/admin/edit-push-notifications'],
          icon: CircleNotificationsIcon,
          permission: 'view-push-notifications',
        },
        {
          title: 'Custom Notification',
          to: '/admin/custom-notifications',
          paths: ['/admin/custom-notifications'],
          icon: CampaignIcon,
          permission: null,
        },
      ],
    },
    {
      title: 'Symptom',
      to: '/admin/symptom',
      paths: ['/admin/symptom', '/admin/add-symptom', '/admin/edit-symptom'],
      icon: HealthAndSafetyIcon,
      permission: 'view-symptoms',
    },
    {
      title: 'Subscription',
      to: '/admin/subscription',
      paths: ['/admin/subscription'],
      icon: SubscriptionsIcon,
      permission: 'subscriptions',
    },
    {
      title: 'Analytics',
      to: '/admin/analytics',
      paths: ['/admin/analytics'],
      icon: AnalyticsIcon,
      permission: "view-push-notifications", // Set to null as requested (before setting)
    },
    {
      title: 'Reports',
      to: '/admin/reports',
      paths: ['/admin/reports'],
      icon: AssessmentIcon,
      permission: "view-reports",
    },
    {
      title: 'Setting',
      to: '/admin/setting',
      paths: ['/admin/setting'],
      icon: SettingsIcon,
      permission: 'settings',
    },
    {
      title: 'Logout',
      to: '/admin/logout',
      paths: ['/admin/logout'],
      icon: LogoutIcon,
      liClassName: 'mb-0',
      spanClassName: 'ms-2',
      permission: null, // Logout always visible
    },
  ];

  const toggleSubmenu = (menuTitle) => {
    setExpandedMenus(prev => ({
      ...prev,
      [menuTitle]: !prev[menuTitle]
    }));
  };

  const isSubmenuExpanded = (menuTitle) => {
    return expandedMenus[menuTitle] || false;
  };

  const isAnySubmenuActive = (submenu) => {
    return submenu.some(item => item.paths?.some(path => location?.pathname === path));
  };

  /*   // Filter menu items based on permissions
    const filterMenuItems = (items) => {
      return items.filter(item => {
        // If no permission required, always show
        if (!item.permission) return true;
  
        // Check permission
        return checkPermission(item.permission);
      });
    }; */

  // Filter submenu items and check if main menu should be shown
  const filterSubmenuItems = (item) => {
    if (!item.hasSubmenu) return item;

    const filteredSubmenu = item.submenu.filter(subItem => {
      if (!subItem.permission) return true;
      return checkPermission(subItem.permission);
    });

    // Only show main menu if at least one submenu item has permission
    if (filteredSubmenu.length === 0) return null;

    return {
      ...item,
      submenu: filteredSubmenu
    };
  };

  // Get filtered menu items
  const filteredSideBarData = sideBarData
    .map(filterSubmenuItems)
    .filter(item => item !== null)
    .filter(item => {
      if (!item.permission) return true;
      return checkPermission(item.permission);
    });

  return (
    <>
      <div className={`d-flex bg-white top-0 ${openSidebar ? "ps-4" : ""}`}>
        {openSidebar && (
          <Link to='/admin/' className='logo ms-3 pt-3'>
            <img src='/images/logo.png' className='header-logo' alt='logo.png' />
          </Link>
        )}
        <div
          className={`${openSidebar ? "ms-auto pe-2" : "d-flex"} pt-1`}
          onClick={() => {
            const next = !openSidebar;
            setOpenSidebar(next);
            if (!next) {
              setExpandedMenus({});
            }
          }}
        >
          <Link to='#' id='toggle_btn' className='header-toggle-btn'>
            <img src='/images/sidebar-menu.png' alt='menu' style={{ width: 50, height: 50 }} />
          </Link>
          <Link to='#' className='mobile_btn' id='mobile_btn'>
            <img src='/images/sidebar-menu.png' alt='menu' style={{ width: 50, height: 50 }} />
          </Link>
        </div>
      </div >
      <div className="d-flex flex-column flex-shrink-0 p-1" style={{ maxwidth: "280px" }}>
        <div className='sidebar-inner slimscroll'>
          <div className='sidebar-menu'>
            <ul className="nav nav-pills flex-column mb-auto p-0">
              {filteredSideBarData.map((item) => {
                const isActive = item.hasSubmenu
                  ? isAnySubmenuActive(item.submenu)
                  : item.paths?.some((p) => location?.pathname === p);

                return (
                  <li key={item.title} className={item.liClassName}>
                    {item.hasSubmenu ? (
                      <>
                        <div
                          className={`text-nowrap d-flex ${isActive ? 'sidemenu-active' : ''}`}
                          onClick={() => toggleSubmenu(item.title)}
                          style={{ cursor: 'pointer' }}
                        >
                          <item.icon className='icon-width-height me-2' />
                          {openSidebar && <span className={item.spanClassName}>{item.title}</span>}
                          {openSidebar && (isSubmenuExpanded(item.title) ? (
                            <ExpandLessIcon className='icon-width-height ms-auto' />
                          ) : (
                            <ExpandMoreIcon className='icon-width-height ms-auto' />
                          ))}
                        </div>
                        {openSidebar && isSubmenuExpanded(item.title) && (
                          <ul className="nav nav-pills flex-column mb-auto p-0 ms-3">
                            {item.submenu.map((subItem) => {
                              const isSubActive = subItem.paths?.some((p) => location?.pathname === p);
                              return (
                                <li key={subItem.to} className="nav-item">
                                  <NavLink
                                    to={subItem.to}
                                    className={isSubActive ? 'text-nowrap d-flex sidemenu-active' : 'text-nowrap d-flex'}
                                  >
                                    <subItem.icon className='icon-width-height me-2' />
                                    {openSidebar && <span className={subItem.spanClassName}>{subItem.title}</span>}
                                  </NavLink>
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </>
                    ) : (
                      <NavLink
                        to={item.to}
                        className={isActive ? 'text-nowrap d-flex sidemenu-active' : 'text-nowrap d-flex '}
                      >
                        <item.icon className='icon-width-height me-2' />
                        {openSidebar && <span className={item.spanClassName}>{item.title}</span>}
                      </NavLink>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminSidebar;
